import { Box, Paper, Tooltip, ActionIcon, Group } from "@mantine/core";
import { IconMinus, IconTrash, IconArrowUp, IconArrowDown, IconArrowLeft, IconArrowRight, } from "@tabler/icons-react";
import { useTranslation } from 'react-i18next';

/**
 * Floating menu for table operations (add/delete rows, columns, delete table).
 */
function TableMenu({ editor }) {
  const { t } = useTranslation();
  if (!editor?.can().deleteTable()) {
    return null;
  }

  return (
    <Paper
      shadow="md"
      p="xs"
      style={{ position: "absolute", zIndex: 1400, display: "flex", gap: 4, border: "1px solid #e0e0e0" }}
    >
      <Group gap={4}>
        <Tooltip label={t('editor.table.insertRowBelow')}>
          <ActionIcon
            size="sm"
            variant="subtle"
            onClick={() => editor.chain().focus().addRowAfter().run()}
          >
            <IconArrowDown size={14} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label={t('editor.table.insertRowAbove')}>
          <ActionIcon
            size="sm"
            variant="subtle"
            onClick={() => editor.chain().focus().addRowBefore().run()}
          >
            <IconArrowUp size={14} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label={t('editor.table.insertColumnLeft')}>
          <ActionIcon
            size="sm"
            variant="subtle"
            onClick={() => editor.chain().focus().addColumnBefore().run()}
          >
            <IconArrowLeft size={14} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label={t('editor.table.insertColumnRight')}>
          <ActionIcon
            size="sm"
            variant="subtle"
            onClick={() => editor.chain().focus().addColumnAfter().run()}
          >
            <IconArrowRight size={14} />
          </ActionIcon>
        </Tooltip>
      </Group>
      <Box
        style={{
          width: 1,
          backgroundColor: "#e0e0e0",
          alignSelf: "stretch",
        }}
      />
      <Group gap={4}>
        <Tooltip label={t('editor.table.deleteRow')}>
          <ActionIcon
            size="sm"
            variant="subtle"
            color="red"
            onClick={() => editor.chain().focus().deleteRow().run()}
          >
            <IconMinus size={14} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label={t('editor.table.deleteColumn')}>
          <ActionIcon
            size="sm"
            variant="subtle"
            color="red"
            onClick={() => editor.chain().focus().deleteColumn().run()}
          >
            <IconMinus size={14} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label={t('editor.table.deleteTable')}>
          <ActionIcon
            size="sm"
            variant="subtle"
            color="red"
            onClick={() => editor.chain().focus().deleteTable().run()}
          >
            <IconTrash size={14} />
          </ActionIcon>
        </Tooltip>
      </Group>
    </Paper>
  );
}

export default TableMenu;
